export type SchwabInboundContactSyncSettings = {
  autoSync: boolean
}

export type SchwabInboundSyncSettings = {
  contact: SchwabInboundContactSyncSettings
}

export type SchwabSettingsFormValues = {
  inbound: SchwabInboundSyncSettings
}

export const schwabSettingsDefaultValues: SchwabSettingsFormValues = {
  inbound: {
    contact: {
      autoSync: false,
    },
  },
}
